/*
 * Copyright © 2015-2022 Serenova, LLC. All rights reserved.
 */

import './nonce';
import React, { Fragment } from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Switch, HashRouter as Router, Route } from 'react-router-dom';

import RootStyles from './containers/RootStyles';

import store from './redux/store';

import PrivateRoute from './PrivateRoute';

import LanguageProvider from './containers/LanguageProvider';
import Login from './containers/Login';
import Navigation from './containers/Navigation';
import SupervisorToolbar from './containers/SupervisorToolbar';
import InteractionManagement from './containers/InteractionManagement';
import InteractionMonitoring from './containers/InteractionMonitoring';
import AgentStateMonitoring from './containers/AgentStateMonitoring';
import BetaFeatures from './containers/BetaFeatures';
import CrudEndpointUi from './containers/CrudEndpointUi';
import FlowDebugLogs from './containers/FlowDebugLogs';
import Flows from './containers/Flows';
import ForecastDashboards from './containers/ForecastDashboards';
import UserProfile from './containers/FullPagePanel/UserProfile';
import Wfm from './containers/Wfm';
import ForgotPassword from './containers/ForgotPassword';
import ResetPassword from './containers/ResetPassword';
import InviteAccept from './containers/InviteAccept';
import ErrorBoundary from './components/ErrorBoundary';

ReactDOM.render(
  <Provider store={store}>
    <LanguageProvider>
      <Router>
        <Switch>
          {/* Branding is not required for SupervisorToolbar and we do not want to display the loading spinner for it */}
          <Route path="/supervisorToolbar" component={SupervisorToolbar} />
          <RootStyles>
            <Fragment>
              <Route exact path="/" component={Login} />
              <Route exact path="/login" component={Login} />
              <Route exact path="/forgot-password" component={ForgotPassword} />
              <Route exact path="/reset-password" component={ResetPassword} />
              <Route exact path="/invite-accept" component={InviteAccept} />
              <Navigation />
              <ErrorBoundary>
              <Route path="/interactionManagement" component={PrivateRoute(InteractionManagement)} />
              <Route path="/interactionMonitoring" component={PrivateRoute(InteractionMonitoring)} />
              <Route path="/agentStateMonitoring" component={PrivateRoute(AgentStateMonitoring)} />
              <Route path="/forecastDashboards" component={PrivateRoute(ForecastDashboards)} />
              <Route path="/wfm/:wfmPage" component={PrivateRoute(Wfm)} />
              <Route path="/early-access-features" component={PrivateRoute(BetaFeatures)} />
              <Route path="/configuration/:entityName" component={PrivateRoute(CrudEndpointUi)} />
              <Route path="/flowDebugLogs" component={PrivateRoute(FlowDebugLogs)} />
              <Route path="/flows/:actionType/:flowId/:id" component={PrivateRoute(Flows)} />
              <Route path="/userProfile" component={PrivateRoute(UserProfile)} />
              </ErrorBoundary>
            </Fragment>
          </RootStyles>
        </Switch>
      </Router>
    </LanguageProvider>
  </Provider>,
  document.getElementById('root')
);
